export const relacionLaboral = [
  { label: 'Dependiente', value: 'dependiente' },
  { label: 'Comerciante/Empresario', value: 'comerciante' },
  { label: 'Profesional independiente', value: 'independiente' },
  { label: 'Jubilado', value: 'jubilado' },
];
